import { Injectable } from '@angular/core';
import { ARLogger } from '@relayter/core';
import { AnalyticsBrowser } from '@segment/analytics-next';
import { environment } from '../../../environments/environment';
import { UserDetailModel } from '../../models/api/user.model';
import { ISegmentService } from './segment.service.interface';

@Injectable({
    providedIn: 'root'
})
export class RLSegmentService implements ISegmentService {
    public static TRACK_ADD_PUBLICATION(name?: string): string {
        return `Add Publication - ${name}`;
    }

    public static TRACK_REMOVE_PUBLICATION(name?: string): string {
        return `Remove Publication - ${name}`;
    }

    private readonly analytics = new AnalyticsBrowser();
    private user: UserDetailModel;

    public initialize() {
        // don't wait, we guard the tracking calls below
        this.analytics.load({ writeKey: environment.SEGMENT_API_KEY }, {}).catch((error) => ARLogger.error(error));
    }

    public setUser(user: UserDetailModel): void {
        this.user = user;
        this.analytics.ready().then(() => {
            this.identify();
        });
    }

    /**
     * Identify user in segmentService and show intercom widget
     */
    public identify(): void {
        this.analytics.ready().then(() => {
            if (this.user?.acceptPolicy === false) {
                ARLogger.warn('the user did not accept tracking, identify events will not be logged');
            } else if (this.user) {
                this.analytics
                    .identify(
                        this.user._id,
                        {
                            name: this.user.fullName,
                            email: this.user.email,
                            company: { id: this.user.team.teamHash, name: this.user.team.name } // team.companyName is not used, so we use the name....
                        },
                        {
                            Intercom: {
                                hideDefaultLauncher: false,
                                user_hash: this.user.userHash
                            }
                        }
                    )
                    .catch((error) => ARLogger.error(error));
            }
        });
    }

    /**
     * Log a page view event to segmentService
     * @param {string} category
     * @param {string} name
     * @param properties
     * @param options
     */
    public page(category?: string, name?: string, properties?: any, options?: any): void {
        if (this.user?.acceptPolicy === false) {
            return ARLogger.warn('the user did not accept tracking, identify events will not be logged');
        }
        this.analytics.ready().then(() => {
            this.analytics.page(category, name, properties, options).catch((error) => ARLogger.error(error));
        });
    }

    /**
     * Log a track event to segmentService
     * @param {string} event
     * @param properties
     * @param options
     */
    public track(event: string, properties?: any, options?: any): void {
        if (this.user?.acceptPolicy === false) {
            return ARLogger.warn('the user did not accept tracking, identify events will not be logged');
        }
        this.analytics.ready().then(() => {
            this.analytics.track(event, properties, options).catch((error) => ARLogger.error(error));
        });
    }
}
